import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum SidebarProductVisibilityPermissionSet {
  ShowOperationsProduct = 'sidebar_product_visibility_show_operations_product',
  ShowEligibilityProduct = 'sidebar_product_visibility_show_eligibility_product',
  ShowResolveProduct = 'sidebar_product_visibility_show_resolve_product',
  ShowAnalyzeProduct = 'sidebar_product_visibility_show_analyze_product',
  ShowAnalyticsProduct = 'sidebar_product_visibility_show_analytics_product',
  ShowEamProduct = 'sidebar_product_visibility_show_eam_product',
  ShowAiProduct = 'sidebar_product_visibility_show_ai_product',
  ShowRealizeProduct = 'sidebar_product_visibility_show_realize_product',
  ShowAdminProduct = 'sidebar_product_visibility_show_admin_product',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const sidebarProductVisibilityPermissionSetGrouping: IPermissionSetGrouping<SidebarProductVisibilityPermissionSet> =
  {
    key: PermissionSetGroupingKey.SidebarProductVisibility,
    active: {
      [SidebarProductVisibilityPermissionSet.ShowOperationsProduct]: [
        PermissionType.SHOW_OPERATIONS_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowEligibilityProduct]: [
        PermissionType.SHOW_ELIGIBILITY_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowResolveProduct]: [
        PermissionType.SHOW_RESOLVE_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowAnalyzeProduct]: [
        PermissionType.SHOW_ANALYZE_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowAnalyticsProduct]: [
        PermissionType.SHOW_ANALYTICS_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowAiProduct]: [
        PermissionType.SHOW_AI_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowRealizeProduct]: [
        PermissionType.SHOW_REALIZE_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowEamProduct]: [
        PermissionType.SHOW_EAM_PRODUCT,
      ],
      [SidebarProductVisibilityPermissionSet.ShowAdminProduct]: [
        PermissionType.SHOW_ADMIN_PRODUCT,
      ],
    },
    unAssignablePermissionSets: [
      SidebarProductVisibilityPermissionSet.ShowAdminProduct,
      SidebarProductVisibilityPermissionSet.ShowEamProduct, // Unassignable because it's not needed for a specific demo.
    ],
  }
